// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AnchorHeading, { AnchorHeadingStyles } from "@store/Library/Components/Toolkit/Anchor/AnchorHeading";
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import React, { FC } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code - End */

const enum fields {
    title = "title",
    anchor = "anchor",
    anchorLabel = "anchorLabel",
}

interface Props extends WidgetProps, ExpandStyles<ProductDetailsAnchorHeadingStyles> {
    fields: {
        [fields.title]: string;
        [fields.anchor]: string;
        [fields.anchorLabel]: string;
    };
}

export interface ProductDetailsAnchorHeadingStyles {
    anchorHeading?: AnchorHeadingStyles;
}

export const productDetailsAnchorHeadingStyles: ProductDetailsAnchorHeadingStyles = {
    anchorHeading: {
        title: {
            variant: null as any,
            forwardAs: "h2",
            css: css`
                ${typographyTitleStyles(pxToRemArray([20, null, 20]))} /* Store Custom Code */
                ${spacingStyles(null, "0.75em")}
                /* Store Custom Code - Start */
                color: ${getColor("header.contrast")};
                font-weight: ${x => x.theme.design.typography.weight.bold};
                /* Store Custom Code - End */
            `,
        },
    },
};

const ProductDetailsAnchorHeading: FC<Props> = ({
    fields: { title, anchor, anchorLabel },
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(productDetailsAnchorHeadingStyles, extendedStyles, overridedStyles);

    return <AnchorHeading title={title} anchor={anchor} label={anchorLabel} extendedStyles={styles.anchorHeading} />;
};

const widgetModule: WidgetModule = {
    component: ProductDetailsAnchorHeading,
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        icon: "anchor",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: fields.anchor,
                displayName: "Anchor",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: fields.anchorLabel,
                displayName: "Anchor Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                isVisible: x => x.fields.anchor,
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
